export function assertWellFormedPath(ptr) {
  if (!ptr.term) {
    throw new Error('SHACL Path must be single node');
  }
}